import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Firebase } from '../../firebase/config';
import AdminLayout from '../../Components/Admin/AdminLayout';
import ButtonSpinner from '../../Components/UI/ButtonSpinner';

function AdminNewsletter() {
  const { t } = useTranslation();
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleSend = (e) => {
    e.preventDefault();
    if (!subject.trim() || !body.trim()) return;
    setLoading(true);
    setResult(null);
    const sendNewsletter = Firebase.functions().httpsCallable('sendNewsletter');
    sendNewsletter({ subject: subject.trim(), body: body.trim() })
      .then((res) => {
        setResult(res.data);
        if (res.data?.sent > 0) {
          setSubject('');
          setBody('');
        }
      })
      .catch((err) => {
        setResult({ error: err.message || 'Failed to send newsletter' });
      })
      .finally(() => setLoading(false));
  };

  return (
    <AdminLayout>
      <h1>{t('admin.newsletter')}</h1>
      <p className="adminHint">{t('admin.newsletterDesc')}</p>

      <form onSubmit={handleSend} className="adminNewsletterForm">
        <label htmlFor="nl-subject">{t('admin.newsletterSubject')}</label>
        <input
          id="nl-subject"
          type="text"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          placeholder={t('admin.newsletterSubjectPlaceholder')}
          required
        />
        <label htmlFor="nl-body">{t('admin.newsletterBody')}</label>
        <textarea
          id="nl-body"
          value={body}
          onChange={(e) => setBody(e.target.value)}
          placeholder={t('admin.newsletterBodyPlaceholder')}
          rows={10}
          required
        />
        <button type="submit" disabled={loading} className="adminNewsletterSendBtn">
          {loading && <ButtonSpinner />}
          {loading ? t('admin.newsletterSending') : t('admin.newsletterSend')}
        </button>
      </form>

      {result && (
        <div className={`adminNewsletterResult ${result.error ? 'error' : 'success'}`}>
          {result.error ? (
            <p>{result.error}</p>
          ) : (
            <p>
              {t('admin.newsletterSentTo', { count: result.sent })}
              {result.skipped > 0 && ` · ${t('admin.newsletterSkipped', { count: result.skipped })}`}
            </p>
          )}
        </div>
      )}
    </AdminLayout>
  );
}

export default AdminNewsletter;
